export const pageIsUnavailable = {
  title: 'pageIsUnavailable',
  iconClass: 'icon-critical-large',
  description: 'tryAgain',
};

export const functionIsUnavailable = {
  title: 'functionIsUnavailable',
  iconClass: 'icon-critical-large',
  description: '',
  links: {
    className: 'go-back-link text-center',
    items: [{
      label: 'callCustomerService',
      type: 'callUs',
      trackLink: {
        id: 'emailPage',
        link: 'smarthelp-email-submit-error-call-customer-service',
      },
    }],
  },
};

export const getEmailSentSuccess = options => ({
  title: 'emailSent',
  description: options.isSmcEnabled ? 'emailSentNotes' : 'nonSmcEmailSentNotes',
  iconClass: '',
  links: {
    className: 'other-page-links',
    items: [{
      label: 'goToMessageCenter',
      href: 'goToMessageCenterUrl',
      trackLink: {
        id: 'emailPage',
        link: 'smarthelp-email-confirmation-go-to-message-center',
      },
      display: options.isSmcEnabled,
    }, {
      label: 'viewYourAccount',
      href: 'viewYourAccountUrl',
      trackLink: {
        id: 'emailPage',
        link: 'smarthelp-email-confirmation-view-your-account',
      },
    }, {
      label: 'visitTheHelpCenter',
      href: 'visitTheHelpCenterUrl',
      trackLink: {
        id: 'emailPage',
        link: 'smarthelp-email-confirmation-visit-help-center',
      },
    }, {
      label: 'visitTheCommunityForum',
      href: 'visitTheCommunityForumUrl', // This is Community link which will served by community.json
      trackLink: {
        id: 'emailPage',
        link: 'smarthelp-email-confirmation-visit-community-forum',
      },
      display: options.hasCommunityAccess,
    }],
  },
});



// WEBPACK FOOTER //
// ./contactUs/constants/NotifierTypes.js